import type { LangCode } from '@/lib/i18n/lang';
import type { BlogPost } from './types';
import { ALL_BLOG_POSTS_RAW } from './posts';
import { withSerbianCyrlBlogPosts } from './withSerbianCyrl';

export type { BlogPost, BlogPostRaw, BlogPostTranslation, BlogExternalRef } from './types';
export { blogCoverSrc } from './types';

const ALL_BLOG_POSTS = withSerbianCyrlBlogPosts(ALL_BLOG_POSTS_RAW);

export function getSortedPosts(): BlogPost[] {
  return [...ALL_BLOG_POSTS].sort((a, b) => (a.published < b.published ? 1 : -1));
}

export function getBlogPost(slug: string): BlogPost | undefined {
  return ALL_BLOG_POSTS.find((p) => p.slug === slug);
}

export function getAllBlogSlugs(): string[] {
  return ALL_BLOG_POSTS.map((p) => p.slug);
}

export function getRelatedPosts(slug: string, lang: LangCode, limit = 3): BlogPost[] {
  const current = getBlogPost(slug);
  if (!current) return [];
  const pool = new Set(current.relatedSlugs);
  return ALL_BLOG_POSTS.filter((p) => p.slug !== slug && pool.has(p.slug)).slice(0, limit);
}
